<template>
	<div>
		<b-row>
			<b-col cols="6" v-if="params.data.oncelik == true"><b-button size="sm"
					style="background-color: #7367F0;     border-color: #7367F0;" v-on:click="
						oncelikIsaretle()
						">
					<Icon icon="mdi:priority-high" width="20" height="20" v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'
						" />
				</b-button></b-col>

			<b-col cols="6" v-else><b-button size="sm" variant="outline-light" v-on:click="
				oncelikIsaretle()
				">
					<Icon icon="mdi:priority-high" width="20" height="20" v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'"
						color="#7367F0" />
				</b-button></b-col>
			<b-col cols="6" v-if="params.data.oncelik == true" style="    padding: 0px !important;"><b-button size="sm"
					v-on:click="kampanyaOlustur(params.data)" style="background-color: #FF9F43;     border-color: #FF9F43;">
					<Icon icon="mdi:discount" width="20" height="20" v-b-tooltip.hover.bottom="'Kampanya oluştur'
						" />
				</b-button></b-col>
			<b-col cols="6" v-else style="    padding: 0px !important;"><b-button size="sm" variant="outline-light"
					v-on:click="kampanyaOlustur(params.data)">
					<Icon icon="mdi:discount" width="20" height="20" v-b-tooltip.hover.bottom="'Kampanya oluştur'"
						color="#FF9F43" />
				</b-button></b-col>
		</b-row>
	</div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
	components: {
    Icon
  },
	methods: {
		oncelikIsaretle() {
			this.$root.$emit("oncelikOlusturBtn", this.params.data);

		},
		kampanyaOlustur(){
			this.$root.$emit("kampanyaOlustur", this.params.data);
			
		},
	}
}
</script>